module.exports = __webpack_public_path__ + "static/media/Yafeng.e9bec464.jpeg";